import { useId } from "react";
import { IconProps } from "./types";

/** Fixed yellow-to-orange gradient per the rating-badge design spec — unlike
 * every other icon here, `color` doesn't apply (the fill is the gradient
 * itself), so it's intentionally left out of the destructure. The gradient
 * id is instanced per-render via `useId` so multiple DriverCards on one page
 * don't collide on the same `<defs>` id. */
export const StarIcon = ({ size = 8, className }: IconProps) => {
  const gradientId = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 8 8" fill="none" className={className} aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m7.336 2.517-1.693-.24a.25.25 0 0 1-.19-.138L4.692.622V.62a.8.8 0 0 0-.337-.337.785.785 0 0 0-1.047.339L2.547 2.14a.25.25 0 0 1-.185.135l-1.698.242a.762.762 0 0 0-.429 1.31l1.23 1.18a.24.24 0 0 1 .07.211l-.292 1.67a.776.776 0 0 0 1.123.807l1.52-.787a.25.25 0 0 1 .233.001l1.512.783a.772.772 0 0 0 1.127-.809l-.29-1.666a.24.24 0 0 1 .069-.21l1.228-1.18a.766.766 0 0 0-.428-1.309"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient id={gradientId} x1=".461" y1=".2" x2=".461" y2="6.911" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ffd602" />
          <stop offset="1" stopColor="#ffad01" />
        </linearGradient>
      </defs>
    </svg>
  );
};
